import {$} from '../jquery-definition.js';

$( function() {
	$( '.home' ).addClass( 'active-info-bubble' );
} );

$( window ).scroll( function() {
	var scrollTop = $( window ).scrollTop();

	if ( scrollTop > 0 ) {
		$( 'body' ).removeClass( 'active-info-bubble' );
	} else {
		$( '.home' ).addClass( 'active-info-bubble' );
	}
} );

$( '.info-bubble-show, .info-2-bubble-show' ).on( 'click', function( clickEvent ) {
	clickEvent.preventDefault();

	var $this = $( this );

	$( 'body' ).addClass( 'active-info-bubble' );
} );

$( '.info-bubble-hide, .info-2-bubble-hide' ).on( 'click', function( clickEvent ) {
	clickEvent.preventDefault();

	var $this = $( this );

	$( 'body' ).removeClass( 'active-info-bubble' );
} );
